import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import Icon from 'components/Icon/Icon';
import styles from '../WorkExperience.module.scss';

const WorkExperienceDetails = ({
  lastEntry,
  index,
  workExperience,
  deleteWorkExperience,
  isOwn,
  user,
}) => {
  const handleDeleteWorkExperience = () => {
    deleteWorkExperience(index);
  };

  const end = !workExperience.end_date
    ? 'Present'
    : moment(workExperience.end_date).format('LL');

  let dates = <i>{end}</i>;
  let topLine = (
    <div>
      <i style={{ color: '#aaa' }}>{workExperience.job_title}</i>
    </div>
  );
  let className = 'mb';

  if (workExperience.start_date) {
    const start = moment(workExperience.start_date).format('LL');
    dates = (
      <i>
        {start} - {end}
      </i>
    );
  }

  if (workExperience.company_name) {
    topLine = (
      <div>
        <i style={{ color: '#aaa' }}>{workExperience.job_title}</i> at{' '}
        {workExperience.company_name}
      </div>
    );
  }

  if (lastEntry) className = '';

  return (
    <div className={`${className} ${styles.oneWorkExperience}`}>
      <div>
        {topLine}
        {dates}
        <div>{workExperience.description}</div>
      </div>
      {user && isOwn && (
        <div>
          <Icon
            icon="&#xe611;"
            style={{ marginLeft: '5px' }}
            onClick={handleDeleteWorkExperience}
          />
        </div>
      )}
    </div>
  );
};

WorkExperienceDetails.propTypes = {
  lastEntry: PropTypes.bool,
  index: PropTypes.number,
  workExperience: PropTypes.object,
  deleteWorkExperience: PropTypes.func,
  isOwn: PropTypes.bool,
  user: PropTypes.object,
};

export default WorkExperienceDetails;
